var _G, _Defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { G, Circle, Defs, LinearGradient, Stop } from "react-native-svg";
/* SVGR has dropped some elements not supported by react-native-svg: filter */
var SvgMilestoneCurrent = function SvgMilestoneCurrent(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    overflow: "visible",
    preserveAspectRatio: "none",
    style: {
      display: "block"
    },
    viewBox: "0 0 30 30"
  }, props), _G || (_G = /*#__PURE__*/React.createElement(G, {
    filter: "url(#milestone-current_svg__a)"
  }, /*#__PURE__*/React.createElement(Circle, {
    cx: 15,
    cy: 15,
    r: 7,
    fill: "url(#milestone-current_svg__b)"
  }))), _Defs || (_Defs = /*#__PURE__*/React.createElement(Defs, null, /*#__PURE__*/React.createElement(LinearGradient, {
    id: "milestone-current_svg__b",
    x1: 15,
    x2: 15,
    y1: 8,
    y2: 22,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement(Stop, {
    stopColor: "#FFD766"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 1,
    stopColor: "#E89200"
  })))));
};
export default SvgMilestoneCurrent;